import React from 'react';
import { Link } from '@tanstack/react-router';

const Hero: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center">
      <div className="relative max-w-4xl w-full mx-auto">
        {/* Glow effect */}
        <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 via-purple-500 to-yellow-500 rounded-2xl blur opacity-30 group-hover:opacity-50 transition duration-1000 group-hover:duration-200 animate-gradient-x"></div>
        
        {/* Semi-transparent overlay only for the hero content */}
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm rounded-2xl" />
        
        {/* Emoji stickers */}
        <div className="absolute top-4 left-4 md:top-12 md:left-12 lg:top-16 lg:left-16 text-5xl md:text-7xl lg:text-8xl transform -rotate-12 opacity-50 md:opacity-100 z-0">💡</div>
        <div className="absolute bottom-4 right-4 md:bottom-12 md:right-12 lg:bottom-16 lg:right-16 text-5xl md:text-7xl lg:text-8xl transform rotate-12 opacity-50 md:opacity-100 z-0">🚀</div>
        
        <div className="relative z-10 space-y-8 p-8 md:p-12">
          <h1 className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-wider font-mono text-black">
            WaldHacks2025
          </h1>
          
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed">
            The world's premier global, virtual, agents hackathon.
            <br/>
            Make apps. Win cash prizes. 💰
            <br/>
          </p>

          <div className="text-lg font-medium text-slate-700">
          📅 June 4–18, 2025
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/hackathon/register"
              className="px-6 py-3 bg-white text-slate-900 border-2 border-cyan-500 hover:bg-cyan-50 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 font-medium"
            >
              → Register now
            </Link>
            <Link
              to="/hackathon/submit"
              className="px-6 py-3 bg-white text-slate-900 border-2 border-purple-500 hover:bg-purple-50 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 font-medium"
            >
              → Submit Project
            </Link>
            <a
              href="https://preswald.com/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-white text-slate-900 border-2 border-yellow-500 hover:bg-yellow-50 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 font-medium"
            >
              → Try Preswald
            </a>
          </div>

          <p className="text-sm text-slate-500">
            Hosted by <a href="https://structuredlabs.com" target="_blank" rel="noopener noreferrer" className="hover:text-slate-700 transition-colors">Structured Labs</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hero; 